import "./App.css";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Home from "./Page/Home";
import About from "./Page/About";
import Terms from "./Page/Terms";
import Blog from "./Page/Blog";
import Partner from "./Page/Partner";
import PartnerListings from "./Page/PartnerListings";
import PartnerProfile from "./Page/PartnerProfile";
import ChatWidget from "./Page/ChatWidget";
import LiveChat from "./Page/LiveChat";

function FloatingWidgets() {
  const { pathname } = useLocation();
  const p = pathname.toLowerCase();
  // Hide customer chat widgets on the partner dashboard and on standalone partner sites
  if (p.startsWith("/partner") || p.startsWith("/p/")) return null;
  return (
    <>
      <ChatWidget />
      <LiveChat />
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Terms" element={<Terms />} />
        <Route path="/Blog" element={<Blog />} />
        <Route path="/partner" element={<Partner />} />
        <Route path="/listings" element={<PartnerListings />} />
        <Route path="/p/:slug" element={<PartnerProfile />} />
      </Routes>
      <FloatingWidgets />
    </Router>
  );
}

export default App;
